@import '~swiper/swiper.scss';
@import '~swiper/components/effect-fade/effect-fade.scss';

:host {
  display: block;
  width: 100%;
  height: fit-content;
}

.responsive-offset.no-lock {
  margin-bottom: calc(var(--responsive-offset-value) * -1vh);

  @media screen and (max-aspect-ratio: 16/9) {
    & {
       margin-bottom: calc(100vw * 9/16 * (var(--responsive-offset-value) / 100) * -1);
    }
  }

  @media screen and (max-width: 767px) {
    margin-bottom: calc(100vw * 9/16 * (var(--responsive-offset-value) / 100) * -1);
  }

  @media screen and (max-width: 685px) {
    margin-bottom: calc(100vh * 0.40 * (var(--responsive-offset-value) / 100) * -1);
  }

  @media screen and (max-width: 685px) and (max-aspect-ratio: 9/16) {
    margin-bottom: calc(100vh * 0.30 * (var(--responsive-offset-value) / 100) * -1);
  }
  
}

.responsive-offset.ratio-lock {
  margin-bottom: calc(var(--responsive-offset-value) * 1vw * 9/16 * -1) !important;
  min-height: unset !important;
}

.swiper-container.swiper-container-banner {
  width: 100%;
  height: calc(100vw * 9/16);
  max-height: var(--max-height);
  min-height: 45vh;
  position: relative;
  z-index: 0;

  @media screen and (max-aspect-ratio: 9/16) {
    min-height: 35vh;
  }
}

.cta-winner-mode {

  @media screen and (max-width: 767px) {
    // height: calc(100vw * 9/16) !important;
    // min-height: 15rem;
    height: 100% !important;
    min-height: unset;
    max-height: unset;
  }

  @media screen and (min-width: 768px) {
    height: calc(24.5rem + 100vw * 1/14) !important;
    min-height: calc(24.5rem + 100vw * 1/14) !important;
  }
}

.cta-mode {

  @media screen and (max-width: 767px) {
    height: calc(100vw * 9/16) !important;
    min-height: 15rem;
  }

  @media screen and (min-width: 768px) {
    height: calc(24.5rem + 100vw * 1/14) !important;
    min-height: calc(24.5rem + 100vw * 1/14) !important;
  }
}

.swiper-wrapper.swiper-wrapper-banner {
  width: 100%;
  height: 100%;
}

.swiper-gradient {
  width: 100%;
  position: absolute;
  z-index: 1;
  bottom: -1px;
  left: 0;
}

::slotted(*){
  width: 100%;
  height: 100%;
}
